import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";
import AniLink from "gatsby-plugin-transition-link/AniLink"
import marked from "marked"

const About = ({ page = false }) => {
  const data = useStaticQuery(graphql`
      query AboutQuery {
          allContentfulZespolOpis {
              nodes {
                  title
                  childContentfulZespolOpisShortDescTextNode {
                      internal {
                          content
                      }
                  }
                  image {
                    gatsbyImageData(width: 1080)
                  }
                  id
              }
          }
      }
  `)

  const Image = () => {
    if (!data?.allContentfulZespolOpis?.nodes[0]?.image?.gatsbyImageData) {
      return <div>Picture not found</div>
    }

    return (
      <GatsbyImage
        image={data.allContentfulZespolOpis.nodes[0].image?.gatsbyImageData} alt={''} />
    );
  }

  const aboutData = data.allContentfulZespolOpis.nodes[0] || null

  return (
    <div id="o-mnie" className={`section about-section`}>
      <div className="about-image">
        <Image />
      </div>
      <div className="about-content">
        <h2 className="section-title">{aboutData?.title}</h2>
        {/*<p*/}
        {/*    dangerouslySetInnerHTML={{*/}
        {/*      __html: marked(*/}
        {/*        aboutData?.childContentfulZespolOpisShortDescTextNode?.internal?.content*/}
        {/*      ),*/}
        {/*    }}*/}
        {/*  />*/}
        <AniLink fade to="/zespol" className="button">Więcej</AniLink>
      </div>
    </div>
  )
}

About.propTypes = {}

About.defaultProps = {}

export default About
